import type { ReactNode } from 'react';
import { RESOURCE_TYPES } from '@kaeliux/shared';
import type { ResourceKey } from '../utils/resourceQuantities';
import { Icon, type IconName } from './ui/Icon';

/** Canonical display order for a resource cost/grant row. */
export const RESOURCE_ORDER = RESOURCE_TYPES;

const RESOURCE_ICON_NAME: Partial<Record<ResourceKey, IconName>> = {
    metal: 'metal',
    minerals: 'mineral',
    gas: 'gas',
    energy: 'energy',
    scrap: 'scrap',
};

const RESOURCE_ACCENT_CLASSES: Record<ResourceKey, string> = {
    metal: 'text-metal',
    minerals: 'text-mineral',
    gas: 'text-gas',
    energy: 'text-energy',
    ozone: 'text-content-secondary',
    scrap: '',
};

/**
 * Icon (or a text fallback for `ozone`, which has no icon glyph in the
 * registry yet) for one resource cost row, tinted with that resource's own
 * accent color — replaces the per-OS emoji glyphs the cost lists used to
 * render (design-system hard rule: no emoji in chrome).
 */
export function resourceCostGlyph(key: ResourceKey): ReactNode {
    const iconName = RESOURCE_ICON_NAME[key];
    const accentClass = RESOURCE_ACCENT_CLASSES[key];
    if (iconName) {
        return <Icon name={iconName} size={14} className={accentClass} aria-hidden="true" />;
    }
    return <span className={`text-micro font-bold ${accentClass}`}>Oz</span>;
}
